import { utils } from 'frontend-js-shared'

export const WIDGET_DATE_RANGE_TO_EXPLORE_OPTION = Object.freeze({
  l7days: utils.dates.PREDEFINED_DATE_RANGES.last7Days,
  l30days: utils.dates.PREDEFINED_DATE_RANGES.last30Days,
  lquarter: utils.dates.PREDEFINED_DATE_RANGES.lastQuarter,
  ytd: utils.dates.PREDEFINED_DATE_RANGES.thisYear,
  alltime: null,
})
